document.addEventListener('variant:change', function(event) {
  const product = event.detail.product;
  const variant = event.detail.variant;
  const featuredMedia = variant["featured_media"];
  const filteredMediaIndexes = getFilteredMediaIndexes(product, variant);
  const mainImages = document.querySelector('[data-main-image]').querySelectorAll('[data-media-id]');
  const secondaryImages = document.querySelector('[data-secondary-images]').querySelectorAll('[data-media-id]');

  if (featuredMedia) {
    mainImages.forEach((image) => image.classList.toggle('hidden', featuredMedia.id != image.dataset.mediaId));
  }
  secondaryImages.forEach((image, index) => image.classList.toggle('hidden', filteredMediaIndexes.includes(index)));
  secondaryImages.forEach((image) => image.classList.toggle('selected', featuredMedia.id == image.dataset.mediaId));

});


function getFilteredMediaIndexes(product, variant) {
  const filteredMediaIds = [];
  product["media"].forEach((media) => {
    let matchMedia = variant["featured_media"] && media["position"] === variant["featured_media"]["position"];
    if (media["alt"]?.includes("#") && media["alt"] !== product["title"]) {
      if (!matchMedia) {
        const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");
        product["options"].forEach((option) => {
          if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
            if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
              filteredMediaIds.push(media["position"] - 1);
            }
          }
        });
      }
    }
  });
  return filteredMediaIds;
}